/** Backend account (Blade) URLs — website CTAs point here */
const ACCOUNT_BASE = (process.env.REACT_APP_ACCOUNT_URL || process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const accountUrl = (path = "") => {
  const p = path.startsWith("/") ? path : `/${path}`;
  return ACCOUNT_BASE ? `${ACCOUNT_BASE}${p}` : p;
};

export const ACCOUNT_LOGIN = accountUrl("/login");
export const ACCOUNT_REGISTER = accountUrl("/register");
export const ACCOUNT_DASHBOARD = accountUrl("/dashboard");
